import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { GraphService } from 'src/app/services/graph.service';
declare const $:any;

@Component({
  selector: 'smart-graph-history',
  templateUrl: './graph-history.component.html',
  styleUrls: ['../graph-color.css','../../platform-color/platform-color.css']
})
export class GraphHistoryComponent implements OnInit {
  @Input() id: string;
  @Output() filter = new EventEmitter<any>();

  form: FormGroup;

  loading: boolean = true;
  loadGraph: boolean = true;
  currentOrg: string;
  currentChildOrg: string;

  filters =[];
  reportDataLeft =[];
  reportDataRight =[];
  event = null;

  colorSetting = [
    "#7cb6ec",
    "#8085e9",
    "#434348",
    "#90ed7d"
  ];

  limitGraphModal: string = '#limitGraphModal';

  constructor(
    private GraphService: GraphService,
    private spinner: NgxSpinnerService,
    private _formBuilder: FormBuilder,
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.spinner.show();
    this.currentOrg = sessionStorage.getItem('Org');
    this.currentChildOrg = sessionStorage.getItem('ChildOrg');

    this.createForm();

    this.form.controls.receive_date.valueChanges.subscribe(
      async (value) => {
        if(value != this.form.value['receive_date']){
          this.getReport();
        }
      }
    );

    this.loading = false;
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
  }

  createForm(){
    this.form = this._formBuilder.group({
      receive_date: [`${moment(new Date()).subtract(90, 'days').format('DD MMM YYYY')} - ${moment(new Date()).format('DD MMM YYYY')}`],
      duration:["60"]
    });
  }

  submitFilter(event){
    this.event = event;
    this.getReport();
  }

  async getReport(){
    this.filters = [];
    this.loadGraph = true;

    if(this.event){
      this.reportDataLeft = [];
      this.reportDataRight = [];

      let data = this.form.getRawValue();
      await Promise.all(this.event.type
        .map(async type=>{

          await Promise.all(this.event.sensor
            .map(async sensor=>{
              
              let filter = {
                duration: data.duration,
                sensor_id: sensor.data.sensor_id,
                sensor_name: sensor.label,
                type: type.id,
                fromTime: moment(data.receive_date.split(" -")[0], 'DD MMM YYYY').set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0}).format('YYYY-MM-DDTHH:mm:ss'),
                toTime: moment(data.receive_date.split(" -")[1], 'DD MMM YYYY').set({'hour': 23, 'minute': 59, 'second': 59, 'millisecond': 0}).format('YYYY-MM-DDTHH:mm:ss')
              };

              this.filters.push(
                {
                  ...filter,
                  thing_id: this.event.thing.find(thin=> thin.id == sensor.data.thing_id).id
                }
              );
              this.filter.emit(this.filters);
              await this.GraphService.getReportData(this.event.thing.find(thin=> thin.id == sensor.data.thing_id).id, filter).then(res=>{
                if(res.data){
                  let points = res.data.sort(function(a,b){
                    if(a.fromTime < b.fromTime) return 1;
                    if(a.fromTime > b.fromTime) return -1;
                    return 0;
                  });;

                  let avg = 0,
                  min = 0, max = 0, sum = 0;

                  points.forEach(function(point, inx) {
                    if (!min || min > parseFloat(point.value)) {
                      min = parseFloat(point.value);
                    }
          
                    if (!max || max < parseFloat(point.value)) {
                      max = parseFloat(point.value);
                    }
                    sum += parseFloat(point.value);
                    avg += parseFloat(point.value);
                  });
                  avg /= points.length;

                  let data = {
                    min: min,
                    max: max,
                    avg: avg,
                    sum: sum,
                    points: points
                  }
   
                  if(this.reportDataLeft.length == 0){
                    this.reportDataLeft.push(data);
                  }else{
                    if(this.reportDataLeft.find(item=> item.points[0].sensor_unit == data.points[0].sensor_unit)){
                      this.reportDataLeft.push(data);
                    }else{
                      this.reportDataRight.push(data);
                    }
                  }
                }
              }).catch(err=>{
                console.log(err);
              });
          }));
      }));

      this.loadGraph = false;
      this.resetTemplate();
    }
  }

  setDuration(duration: string){
    this.form.get('duration').setValue(duration);
  }

  resetTemplate(){
    this.cd.detectChanges();
  }
}
